<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="chart-carusel-block" :class="type !== 'normal' && 'white-background'">
    <div class="has-side-bars">
      <h2 v-if="type === 'normal'" class="preview-title">{{ $t('bcn_data') }}</h2>
      <div class="tesaurus-buttons">
        <div
          v-for="(saurus, i) in thesaurus.theme"
          :key="saurus.label"
          class="tesaurus-button"
          :class="(previewStateOption === saurus.label ? 'active' : '') || (type === 'views-list' && availableFilters.indexOf(saurus.label) === -1 ? 'disabled' : '')"
          @click="() => togglePreviewState(saurus.label)"
        >
          <div class="tesaurus-button-icon">
            <!-- TOOD: usar el "id" que se inyecta en la api!!!!!-->
            <div v-if="i === 0" class="icon-population" />
            <div v-if="i === 1" class="icon-economy" />
            <div v-if="i === 2" class="icon-urban" />
            <div v-if="i === 3" class="icon-transp" />
            <div v-if="i === 4" class="icon-habitage" />
            <div v-if="i === 5" class="icon-society" />
            <div v-if="i === 6" class="icon-politics" />
            <div v-if="i === 7" class="icon-admin" />
            <div v-if="i === 8" class="icon-carto" />
          </div>
          <div class="tesaurus-button-text">{{ saurus.label.replace('~', ',') }}</div>
        </div>
      </div>
      <div v-if="type === 'normal'" class="injected-charts">
        <chart-carousel :thesaurus-id="previewStateOption" />
      </div>
      <div v-else>
        <div v-if="showedFavs && showedFavs.length > 0">
          <div class="charts-wrap">
            <div v-for="(view, i) in showedFavs" :key="i" class="chart-view">
              <injected-chart
                :key="view.id"
                :config="view"
                :visible="true"
                :type="type"
                :fav-id="view.favouriteId"
                @reload="reloadData"
              />
            </div>
          </div>
        </div>
        <div v-else class="err-wrap">
          <span>{{ $t('no_views_fav') }}</span>
        </div>
        <div class="centered-content">
          <PaginationSearch :data-search="dataSearch" :items-for-page="itemsForPage" @toggle-data-loading="() => {}" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartCarousel from '../charts/ChartCarousel.vue'
import InjectedChart from '../charts/InjectedChart.vue'
import PaginationSearch from '../search/PaginationSearch.vue'
import { getUserFavs } from '@/services/user-api'

export default {
  components: {
    ChartCarousel,
    InjectedChart,
    PaginationSearch,
  },
  props: {
    thesaurus: {
      type: Object,
    },
    type: {
      type: String,
      default: 'normal',
    },
  },
  data() {
    return {
      previewStateOption: this.type === 'views-list' ? '' : this.thesaurus.theme[0].label,
      itemsForPage: 2,
      reloadTimes: 0,
    }
  },
  computed: {
    availableFilters() {
      let res = []
      if (this.favViewsLib) {
        this.favViewsLib.forEach(el => {
          el.thesaurus.forEach(elem => {
            if (res.indexOf(elem) === -1) {
              res.push(elem)
            }
          })
        })
      }
      return res
    },
    dataSearch() {
      return { count: (this.compFavViews && this.compFavViews.length) || null }
    },
    showedFavs() {
      let initial = this.$route.query.page ? (this.$route.query.page - 1) * this.itemsForPage : 0
      let filFil = null
      if (this.compFavViews) {
        filFil = this.compFavViews.map(a => a)
        //FILTER THEME
        //SORT BY FILTER APPLY
        if (this.$route.query?.sortBy) {
          if (this.$route.query.sortBy === 'text-asc') {
            filFil = filFil.sort((a, b) => {
              return a.title > b.title ? 1 : -1
            })
          } else if (this.$route.query.sortBy === 'text-desc') {
            filFil = filFil.sort((a, b) => {
              return a.title > b.title ? -1 : 1
            })
          } else if (this.$route.query.sortBy === 'date-asc') {
            filFil = filFil.sort((a, b) => {
              return new Date(a.publishDate) - new Date(b.publishDate)
            })
          } else if (this.$route.query.sortBy === 'date-desc') {
            filFil = filFil.sort((a, b) => {
              return new Date(b.publishDate) - new Date(a.publishDate)
            })
          } else if (this.$route.query.sortBy === 'create-asc') {
            filFil = filFil.sort((a, b) => {
              return new Date(a.dateCreated) - new Date(b.dateCreated)
            })
          } else if (this.$route.query.sortBy === 'create-desc') {
            filFil = filFil.sort((a, b) => {
              return new Date(b.dateCreated) - new Date(a.dateCreated)
            })
          }
        }
      }
      return (filFil && filFil.slice(initial, initial + 2)) || null
    },
    compFavViews() {
      if (this.favViewsLib) {
        if (this.previewStateOption === '') {
          return this.favViewsLib
        } else
          return this.favViewsLib.filter(el => el.thesaurus.indexOf(this.previewStateOption) !== -1)
      } else return null
    },
  },
  asyncComputed: {
    favViewsLib() {
      this.reloadTimes
      return getUserFavs(
        this.$store.state.i18n.lang,
        'LIBRARY'
        // this.previewStateOption
      )
        .then(resp => {
          if (resp.code === 500 || resp.code === 401) {
            this.$store.dispatch('deleteUser').then(() => this.$router.push({ name: 'Cover' }))
          }
          return resp
        })
        .then(resp => {
          return resp.data.map(el => {
            let langSource = null
            if (this.$store.state.i18n.lang === 'ca') langSource = 'estad%C3%ADstiques'
            else if (this.$store.state.i18n.lang === 'es') langSource = 'estad%C3%ADsticas'
            else if (this.$store.state.i18n.lang === 'en') langSource = 'statistics'
            el.url = langSource + '/' + el.id + '?' + el.payload
            el.kpis = []
            return el
          })
        })
      // return this.fakeViewsLib
    },
  },
  watch: {
    thesaurus() {
      this.previewStateOption = this.type === 'views-list' ? '' : this.thesaurus.theme[0].label
    },
  },
  methods: {
    reloadData() {
      this.reloadTimes += 1
    },
    togglePreviewState(saurus) {
      if (this.type === 'views-list' && this.availableFilters.indexOf(saurus) !== -1)
        this.previewStateOption = this.previewStateOption === saurus ? '' : saurus
      else if (this.type !== 'views-list') this.previewStateOption = saurus
      if (Object.keys(this.$route.query).length > 0) {
        let queryPartial = { ...this.$route.query }
        delete queryPartial.page
        this.$router.push({ name: 'Profile', params: { params: this.$route.params.params, optype: this.$route.params.optype }, query: queryPartial })
      }
      // this.$router.push({
      //     query: {
      //       ...this.$route.query,
      //       theme: saurus,
      //     },
      //   })
    },
  },
}
</script>

<style lang="stylus" scoped>
.chart-carusel-block
  padding-top: vw(76px)
  padding-bottom: vw(66px)
  background: linear-gradient(135deg, rgba(#54AEEF, 0.1) 0, rgba(#7360EA, 0.1) 100%)

  .mobile &
    padding-top: vw(20px)
    padding-bottom: vw(20px)

  &.white-background
    margin-top: vw(15px)
    background: none

.preview-title
  m-font-size(32, 44)
  margin-block-start: 0
  margin-block-end: vw(30px)
  color: #000
  font-weight: 600

.centered-content
  display: flex
  justify-content: center
  width: 100%

.err-wrap
  display: flex
  justify-content: center
  padding: vw(25px) 0

  span
    m-font-size(18, 20)
    font-weight: 600

.charts-wrap
  display: flex
  flex-wrap: wrap
  justify-content: space-between

  .mobile &
    flex-direction: column
    gap: vw(15px)

  .chart-view
    min-height: vw(200px)
    width: 49%

    .mobile &
      width: 100%

.tesaurus-buttons
  display: flex
  justify-content: space-between
  padding-bottom: vw(30px)
  gap: vw(10px)

  .mobile &
    overflow-x: scroll
    padding-bottom: vw(10px)
    margin-bottom vw(20px)

.tesaurus-button
  display: flex
  flex: 1 1 0%
  flex-direction: column
  align-items: center
  cursor: pointer
  gap: vw(10px)

  &.disabled
    cursor: default

    .tesaurus-button-icon
      border: none
      background-color: $light-grey

      [class*="icon-"]
        background-color: $grey-dark !important

    .tesaurus-button-text
      color: $grey-grey

  &:hover
    .tesaurus-button-icon
      border-color: $corporate_color

      [class*="icon-"]
        background-color: $corporate_color

  &:active,
  &.active
    .tesaurus-button-icon
      border-color: $corporate_color
      background-color: $corporate_color

      [class*="icon-"]
        background-color: #fff

    .tesaurus-button-text
      color: $corporate_color

.tesaurus-button-icon
  display: flex
  justify-content: center
  align-items: center
  width: vw(80px)
  height: vw(80px)
  border: 1px solid #fff
  border-radius: 50%
  background-color: #fff
  box-shadow: 0 4px 80px rgba(0, 0, 0, 0.05)

  .icon-population
    m-icon("population", 48)

  .icon-economy
    m-icon("economy", 48)

  .icon-urban
    m-icon("urban", 48)

  .icon-transp
    m-icon("transp", 48)

  .icon-habitage
    m-icon("habitage", 48)

  .icon-society
    m-icon("society", 48)

  .icon-politics
    m-icon("politics", 48)

  .icon-admin
    m-icon("admin", 48)

  .icon-carto
    m-icon("carto", 48)

.tesaurus-button-text
  m-font-size(14, 20)
  color: #000
  text-align: center
</style>
